import {XauditModel} from '../../../../models/xaudit.model';

export class AnesthesiaEndoAutofillConfigurationModel extends XauditModel {
  AnesthesiaEndoAutofillID: string;
  Name: string;
  enumAnestQuantityID: string;
  enumAnestTypeID: string;
  enumAnestAnesthesiaID: string;

  
  isModelValid(): boolean {
    return (this.Name != null && this.enumAnestQuantityID != null && this.enumAnestTypeID != null && this.enumAnestAnesthesiaID != null);
  }
  
}
